<script setup>
// Cor: nome do tema (segue o kit da marca) ou hex livre; "Automática" deixa
// o renderizador escolher o contraste e "Sem fundo" grava null.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { themeColor } from '../canvas/canvasStyles';
import { recentColors } from './recentColors';

const props = defineProps({
  modelValue: { type: String, default: null },
  theme: { type: Object, default: () => ({}) },
  allowAuto: { type: Boolean, default: false },
  allowNone: { type: Boolean, default: false },
  label: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const SWATCHES = ['primary', 'accent', 'text', 'surface', 'white', 'dark'];
const hex = computed(
  () => themeColor(props.modelValue, props.theme) || '#ffffff'
);
const pickHex = value => {
  recentColors.value = [
    value,
    ...recentColors.value.filter(c => c !== value),
  ].slice(0, 6);
  emit('update:modelValue', value);
};
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <span v-if="label" class="text-xs font-medium text-n-slate-11">
      {{ label }}
    </span>
    <div class="flex flex-wrap items-center gap-1.5">
      <button
        v-for="name in SWATCHES"
        :key="name"
        type="button"
        class="size-6 rounded-full border"
        :class="
          modelValue === name
            ? 'border-n-brand ring-2 ring-n-brand/40'
            : 'border-n-weak'
        "
        :style="{ backgroundColor: themeColor(name, theme) }"
        :title="name"
        @click="emit('update:modelValue', name)"
      />
      <label
        class="relative size-6 cursor-pointer overflow-hidden rounded-full border border-n-weak"
      >
        <input
          type="color"
          class="absolute inset-0 size-full cursor-pointer opacity-0"
          :value="hex"
          @change="pickHex($event.target.value)"
        />
        <span class="i-lucide-pipette absolute inset-1 text-n-slate-11" />
      </label>
      <button
        v-for="c in recentColors"
        :key="c"
        type="button"
        class="size-6 rounded-full border"
        :class="
          modelValue === c
            ? 'border-n-brand ring-2 ring-n-brand/40'
            : 'border-n-weak'
        "
        :style="{ backgroundColor: c }"
        :title="c"
        @click="emit('update:modelValue', c)"
      />
      <button
        v-if="allowAuto"
        type="button"
        class="rounded-md px-2 py-0.5 text-xs"
        :class="
          modelValue == null ? 'bg-n-brand/10 text-n-brand' : 'text-n-slate-11'
        "
        @click="emit('update:modelValue', null)"
      >
        {{ t('EMAIL_TEMPLATES.EDITOR.PROPS.COLOR_AUTO') }}
      </button>
      <button
        v-if="allowNone"
        type="button"
        class="rounded-md px-2 py-0.5 text-xs"
        :class="
          modelValue == null ? 'bg-n-brand/10 text-n-brand' : 'text-n-slate-11'
        "
        @click="emit('update:modelValue', null)"
      >
        {{ t('EMAIL_TEMPLATES.EDITOR.PROPS.BG_NONE') }}
      </button>
    </div>
  </div>
</template>
